var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex tab-custom"},_vm._l((_vm.tabs),function(item){return _c('div',{key:item.id,staticClass:"tab-custom-pane",class:{'active': _vm.defaultActive === item.id},on:{"click":function($event){return _vm.tabChanged(item.id)}}},[_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }